import { render } from "./GanttContextMenu.vue?vue&type=template&id=315b394d&scoped=true&ts=true"
import script from "./GanttContextMenu.vue?vue&type=script&lang=ts"
export * from "./GanttContextMenu.vue?vue&type=script&lang=ts"

import "./GanttContextMenu.vue?vue&type=style&index=0&id=315b394d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315b394d"]])

export default __exports__